<template>
  <div class="exhibition-list-page">
    <BackBtn
      style="z-index: 1;"
      @click.native="onClickPageBack"
    />

    <!-- 放大查看相关 -->
    <div
      v-if="showMask"
      class="mask"
      @click.self="onClickCloseMask"
    >
      <div
        v-if="videoSrc"
        class="video-wrapper"
      >
        <video
          :src="videoSrc"
          controls
          autoplay
          playsinline
        />
      </div>
      <div
        v-if="imageSrc"
        class="image-wrapper"
      >
        <img
          draggable="false"
          class="large-image"
          :src="imageSrc"
          alt=""
        >
      </div>
      <img
        draggable="false"
        src="@/assets/image/close2.png"
        alt=""
        class="close"
        @click="onClickCloseMask"
      >
    </div>

    <div
      v-if="showIframe"
      class="iframe-wrapper"
    >
      <iframe
        :src="linkSrc"
        frameborder="0"
      />
      <BackBtn @click.native="onClickCloseIframe" />
    </div>

    <article class="description">
      <h3>{{ title }}</h3>
      <p
        v-if="choosenExhibition.textDetail"
        class="detail"
      >
        {{ choosenExhibition.textDetail }}
      </p>
      <p
        v-if="choosenExhibition.remark"
        class="remark"
      >
        备注：{{ choosenExhibition.remark }}
      </p>
    </article>

    <div
      class="tab-bar"
      :style="{
        pointerEvents: (tabItemNumber <= 1) ? 'none' : ''
      }"
    >
      <button
        v-if="choosenExhibition.link.length"
        :class="{active: curTabIdx === 0}"
        @click="curTabIdx = 0"
      >
        虚拟展厅
      </button>
      <button
        v-if="choosenExhibition.video.length"
        :class="{active: curTabIdx === 1}"
        @click="curTabIdx = 1"
      >
        展览视频
      </button>
      <button
        v-if="choosenExhibition.imageNumber"
        :class="{active: curTabIdx === 2}"
        @click="curTabIdx = 2"
      >
        展览图片
      </button>
    </div>

    <div
      v-show="curTabIdx === 0"
      class="link-wrap"
    >
      <button
        v-for="(item) of choosenExhibition.link"
        :key="item.link"
        @click="onClickLink(item.link)"
      >
        <img
          draggable="false"
          class="cover-img"
          :src="`${$backEndBaseUrl}exhibition-data/${$route.query.exhibitionId}/${item.cover}`"
          alt=""
        >
        <img
          draggable="false"
          src="@/assets/image/virtual-exhibition-hall-link-icon.png"
          alt=""
          class="link-icon"
        >
      </button>
      <div
        v-if="choosenExhibition.link.length === 0"
        class="no-data"
      >
        <img
          draggable="false"
          src="@/assets/image/no-data.png"
          alt=""
        >
        <div>敬请期待</div>
      </div>
    </div>

    <div
      v-show="curTabIdx === 1"
      class="video-wrap"
    >
      <button
        v-for="(item) of choosenExhibition.video"
        :key="item.video"
        @click="onClickVideo(item.video)"
      >
        <img
          draggable="false"
          class="cover-img"
          :src="`${$backEndBaseUrl}exhibition-data/${$route.query.exhibitionId}/${item.cover}`"
          alt=""
        >
        <img
          draggable="false"
          src="@/assets/image/play-2.png"
          alt=""
          class="link-icon"
        >
        <!-- <h3>{{ item.video.split('.').slice(0, item.video.split('.').length - 1).join('') }}</h3> -->
      </button>
      <div
        v-if="choosenExhibition.video.length === 0"
        class="no-data"
      >
        <img
          draggable="false"
          src="@/assets/image/no-data.png"
          alt=""
        >
        <div>敬请期待</div>
      </div>
    </div>

    <div
      v-show="curTabIdx === 2"
      ref="image-wrap"
      class="image-wrap"
    >
      <img
        v-if="choosenExhibition.imageNumber > 0"
        draggable="false"
        class="first-image"
        :src="imageList[0]"
        alt=""
        @click="onClickExhibitionImage(0)"
      >
      <waterfall
        v-if="choosenExhibition.imageNumber > 1 && canShow"
        :col="2"
        :width="waterfallImgWidth"
        :gutter-width="gutterWidth"
        :data="[]"
      >
        <template>
          <div
            v-for="(item, index) in imageList.slice(1, imageList.length)"
            :key="index"
            class="waterfall-item"
            :style="{
              marginBottom: gutterWidth - 3 + 'px'
            }"
          >
            <img
              draggable="false"
              :src="item"
              alt="加载错误"
              @click="onClickExhibitionImage(index + 1)"
            >
          </div>
        </template>
      </waterfall>
      <div
        v-if="choosenExhibition.imageNumber === 0"
        class="no-data"
      >
        <img
          draggable="false"
          src="@/assets/image/no-data.png"
          alt=""
        >
        <div>敬请期待</div>
      </div>
    </div>

    <img
      draggable="false"
      class="background-image"
      src="@/assets/image/bg-text.png"
      alt=""
    >
  </div>
</template>

<script>
import exhibitionData from "@/exhibitionData.js"

export default {
  components: {
  },
  data() {
    const dataItem = exhibitionData[this.$route.query.exhibitionType][this.$route.query.exhibitionId]

    const hasLink = dataItem.link.length
    const hasVideo = dataItem.video.length
    const hasImage = dataItem.imageNumber

    let initialCurTabIdx = 0
    if (hasLink) {
      initialCurTabIdx = 0
    } else if (hasVideo) {
      initialCurTabIdx = 1
    } else if (hasImage) {
      initialCurTabIdx = 2
    } else {
      console.error('场景、视频、图片都没有！')
    }

    const tabItemNumber = (hasLink ? 1 : 0) + (hasVideo ? 1 : 0) + (hasImage ? 1 : 0)

    return {
      exhibitionData,
      showMask: false,
      showIframe: false,
      videoSrc: null,
      imageSrc: null,
      linkSrc: null,
      curTabIdx: initialCurTabIdx,
      tabItemNumber,
      canShow: false, // 延迟加载瀑布流组件，才能保证图片被分为两列。这组件真垃圾。
    }
  },
  computed: {
    choosenExhibition() {
      return this.exhibitionData[this.$route.query.exhibitionType][this.$route.query.exhibitionId]
    },
    title() {
      return this.choosenExhibition.title.split('<br>').join('')
    },
    topItemImage() {
      if (this.choosenExhibition.imageNumber !== 0) {
        return {
          src: `${this.$backEndBaseUrl}exhibition-data/${this.$route.query.exhibitionId}/1.jpg`,
        }
      } else {
        return null
      }
    },
    imageList() {
      let ret = []
      for (let index = 0; index < this.choosenExhibition.imageNumber; index++) {
        ret.push(`${this.$backEndBaseUrl}exhibition-data/${this.$route.query.exhibitionId}/${index + 1}.jpg`)
      }
      // ret.shift()
      return ret
    },
    waterfallImgWidth() {
      if (window.innerWidth < this.$oneRemToPx * 40) {
        return (window.innerWidth - this.gutterWidth - this.$oneRemToPx * 0.91 * 2) / 2 - 1 // 考虑到小数计算取整的误差，最后要减去一些宽度以保证能放下两列。
      } else {
        return (this.$oneRemToPx * 40  - this.gutterWidth - this.$oneRemToPx * 0.91 * 2) / 2 - 1 // 考虑到小数取整的误差，最后要减去一些宽度以保证能放下两列。
      }
    },
    gutterWidth() {
      return this.$oneRemToPx * 0.78
    }
  },
  watch: {
  },
  mounted() {
    setTimeout(() => {
      this.canShow = true
    }, 1000)
  },
  destroyed() {
    // qq浏览器的bug：本组件被销毁后，视频元素依然存在。需要刷新页面。
    if (window.navigator.userAgent.includes('MQQBrowser') && this.videoSrc) {
      history.go()
    }
  },
  methods: {
    onClickPageBack() {
      this.$router.go(-1)
    },
    onClickCloseMask() {
      this.showMask = false
      this.videoSrc = null
    },
    onClickCloseIframe() {
      this.showIframe = false
      this.linkSrc = null
    },
    onClickExhibitionImage(index) {
      this.showMask = true
      this.imageSrc = this.imageList[index]
    },
    onClickLink(linkSrc) {
      this.showIframe = true
      this.linkSrc = linkSrc
      // window.open(linkSrc)
    },
    onClickVideo(videoSrc) {
      this.showMask = true
      this.videoSrc = `${this.$backEndBaseUrl}exhibition-data/${this.$route.query.exhibitionId}/${videoSrc}`
    }
  },
}
</script>

<style lang="less" scoped>
::-webkit-scrollbar { width: 0; height: 0; } /*宽度是对垂直滚动条而言，高度是对水平滚动条而言*/

.exhibition-list-page {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding-left: 0.91rem;
  padding-right: 0.91rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  max-width: 40rem;
  margin-left: auto;
  margin-right: auto;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.9);
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .video-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      video {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .image-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .close {
      position: fixed;
      top: 0.84rem;
      left: 0.41rem;
      width: 0.63rem;
      padding: 0.5rem;
      cursor: pointer;
    }
    h2 {
      font-size: 0.91rem;
      font-family: Microsoft YaHei;
      color: #FFFFFF;
      margin: 1rem 0 0.77rem;
      line-height: 1.5rem;
    }
    p {
      font-size: 0.75rem;
      font-family: Microsoft YaHei;
      color: #FFFFFF;
      line-height: 1.3rem;
    }
  }
  .iframe-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  > .description {
    flex: 0 0 auto;
    > h3 {
      text-align: center;
      font-size: 0.75rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #727272;
      margin-top: calc(1.23rem - (1.33rem - 0.75rem) / 2);
      line-height: 1.33rem;
    }
    > .detail {
      font-size: 0.75rem;
      font-family: Source Han Sans CN;
      color: #6C6C6C;
      line-height: 1.25rem;
      text-indent: 2em;
      margin-top: calc(0.92rem - (1.25rem - 0.75rem) / 2 - (1.33rem - 0.75rem) / 2);
    }
    > .remark {
      font-size: 0.75rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FF4A03;
      line-height: 1.25rem;
      margin-top: calc(0.86rem - (1.25rem - 0.75rem) / 2 - (1.25rem - 0.75rem) / 2);
    }
  }
  > .tab-bar {
    flex: 0 0 auto;
    height: 1.34rem;
    background-color: rgba(255, 74, 3, 0.05);
    display: flex;
    border-bottom: 0.03rem solid #FF4A03;
    margin-top: calc(1.06rem - (1.25rem - 0.75rem) / 2);
    margin-bottom: 1.41rem;
    > button {
      flex: 1 1 auto;
      background: none;
      border: none;
      font-size: 0.75rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #3F3F3F;
      transition: background-color 0.333s;
      &.active {
        background-color: #FF4A03;
        color: white;
      }
    }
  }
  > .link-wrap {
    flex: 1 1 auto;
    overflow: auto;
    > button {
      display: block;
      position: relative;
      border: none;
      background: none;
      margin-bottom: 0.78rem;
      width: 100%;
      > .cover-img {
        width: 100%;
        border-radius: 0.47rem;
      }
      > .link-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1.41rem;
        height: 1.41rem;
      }
    }
    > .no-data {
      text-align: center;
      > img {
        width: 9.41rem;
      }
      > div {
        font-size: 1.41rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #7F7F7F;
        margin-top: 1rem;
      }
    }
  }
  > .video-wrap {
    flex: 1 1 auto;
    text-align: center;
    overflow: auto;
    > button {
      display: block;
      position: relative;
      border: none;
      background: none;
      margin-bottom: 0.78rem;
      width: 100%;
      > .cover-img {
        width: 100%;
        border-radius: 0.47rem;
      }
      > .link-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1.41rem;
        height: 1.41rem;
      }
    }
    > .no-data {
      text-align: center;
      > img {
        width: 9.41rem;
      }
      > div {
        font-size: 1.41rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #7F7F7F;
        margin-top: 1rem;
      }
    }
  }
  > .image-wrap {
    flex: 1 1 auto;
    overflow: auto;
    .first-image {
      width: 100%;
      border-radius: 0.47rem;
      margin-bottom: 0.7rem;
    }
    .waterfall-item {
      > img {
        width: 100%;
        border-radius: 0.47rem;
      }
    }
    > .no-data {
      text-align: center;
      > img {
        width: 9.41rem;
      }
      > div {
        font-size: 1.41rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #7F7F7F;
        margin-top: 1rem;
      }
    }
  }
  .background-image {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>

<style>
.loading.ball-beat {
  display: none;
}
.vue-waterfall-easy-container .vue-waterfall-easy a.img-inner-box {
  box-shadow: none !important;
  overflow: hidden;
  border-radius: 0.47rem !important;
}
</style>
